export class Permission {
  allowCreating: boolean;
  allowReading: boolean;
  allowUpdating: boolean;
  allowDeleting: boolean;
  constructor() {
    this.allowCreating = false;
    this.allowReading = false;
    this.allowUpdating = false;
    this.allowDeleting = false;
  }
}
